import { defineComponent as _defineComponent } from 'vue'
import FormLayout from '@/components/common/FormLayout.vue'
import VsSnackbar from '@/components/vision/VsSnackbar.vue'
import TagsEditor from '@/components/common/tags/TagsEditor.vue'
import { SnackType } from '@/components/vision/SnackBarType'
import { computed, ref, toRef } from 'vue'
import {
  BulkUpdateTagsOperation,
  useBulkUpdateTags,
  useGetJobTagsQuery,
} from '@/api/jobs'
import { useHubs } from '@/common/useHubs'
import { useJobTagsStore } from '@/components/jobs/jobTagsStore'
import { useJobBottomSheetStatesStore } from '@/components/jobs/jobBottomSheetStatesStore'
import NewTag from '@/models/new_tag'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobTagsEditor',
  props: {
    jobId: null
  },
  emits: ['tags-updated'],
  setup(__props: any, { emit }) {

const props = __props as {
  jobId?: string | null // Job UUID - If null, then we are creating new jobs
}


const isNewJob = computed(() => !props.jobId)
const jobTagsStore = useJobTagsStore()
const jobBottomSheetStatesStore = useJobBottomSheetStatesStore()

const { currentHub } = useHubs()

const isSnackbarVisible = ref(false)
const snackbarMessage = ref()
const snackbarType = ref(SnackType.ERROR)


const jobIdRef = toRef(props, 'jobId')
const { data: tags, isFetched: isTagsFetched } = useGetJobTagsQuery(jobIdRef)
const { mutateAsync: overwriteTags, isLoading: isOverwritingTags } =
  useBulkUpdateTags()

const initialTags = computed(() => {
  if (props.jobId) {
    return tags.value || []
  }
  return jobTagsStore.draftTags
})

const tagsEditor = ref()
const hasChanges = computed(() => tagsEditor.value?.hasChanges ?? false)
const handleSave = async () => {
  if (!jobIdRef.value) {
    jobTagsStore.setDraftTags(
      tagsEditor.value?.currentTags.filter((tag) => tag.isEditable) ?? []
    )
  } else {
    await overwriteTags({
      jobIds: [jobIdRef.value],
      tags:
        tagsEditor.value?.currentTags
          .filter((tag: NewTag) => tag.isEditable)
          .map((tag: NewTag) => NewTag.toObject(tag).toDisplayString) ?? [],
      operation: BulkUpdateTagsOperation.OVERWRITE,
    })
  }

  jobBottomSheetStatesStore.setJobBottomSheetStates({
    isTagBottomSheetVisible: false,
  })
  emit('tags-updated')
}

const handleDismiss = () => {
  if (hasChanges.value) {
    const confirmation = window.confirm(
      'There are unsaved changes, are you sure you want to discard them?'
    )

    if (!confirmation) {
      return
    }
  }
  jobBottomSheetStatesStore.setJobBottomSheetStates({
    isTagBottomSheetVisible: false,
  })
}

const handleError = (err: never) => {
  snackbarMessage.value = err
  isSnackbarVisible.value = true
}

return { __sfc: true,props, isNewJob, jobTagsStore, jobBottomSheetStatesStore, currentHub, isSnackbarVisible, snackbarMessage, snackbarType, emit, jobIdRef, tags, isTagsFetched, overwriteTags, isOverwritingTags, initialTags, tagsEditor, hasChanges, handleSave, handleDismiss, handleError, FormLayout, VsSnackbar, TagsEditor }
}

})